<template>
    <div class="etp-application">

        <div v-if="approvedAndReadyToMakeFirstPayment" class="alert alert-info mt-5 mb-0">
            {{ __('Your application has been approved') }}.<br>
            {{ __('Make your first Training Quarter Payment to start your classes') }}. <a href="/electrical-training-program/make-a-payment">{{ __('Make a Payment') }}</a>
        </div>

        <div class="text-danger text-center mt-3">
           {{ __('Once you start the application process for the ET program, you must make the first quarter payment within 90 days of submission or your application will be deleted.') }}
       </div>

        <form-wizard ref="application"
                     title=""
                     subtitle=""
                     color="#2F363A">

            <tab-content :title="__('Personal Details')" icon="far fa-id-card">
                <div class="section mb-5">

                    <field-select v-model="form.type" name="type" :label="__('Type of Program')" >
                        <option value="english_online">{{ __('English') }}</option>
                        <option value="spanish_online">{{ __('Spanish') }}</option>
                    </field-select>

                    <field-input v-model="form.address" label="Address" id="autocomplete-address"></field-input>

                    <div class="row">
                        <div class="col-md-4">
                            <field-input v-model="form.city" label="City"></field-input>
                        </div>
                        <div class="col-md-4">
                            <field-input v-model="form.state" label="State"></field-input>
                        </div>
                        <div class="col-md-4">
                            <field-input v-model="form.zip" label="Zip"></field-input>
                        </div>
                    </div>

                    <field-datetime v-model="form.birth_date" format="Y-MM-DD" :with-time="false" name="birth_date" label="Birth Date"></field-datetime>
                    <field-input v-model="form.driver_license" name="driver_license" label="Goverment ID #" sublabel="(Driver's License, ID Card, Etc...)"></field-input>
                    <field-file v-model="form.file_id"
                                v-if="!form.goverment_id_file_attached_at"
                                model="App\Models\User"
                                :model-id="userId"
                                name="file_id"
                                label="Upload a copy of your Goverment ID"
                                @uploaded="updateGovermentIdFileAttachedEvent">
                    </field-file>

                    <field-select v-model="form.shirt_size" name="shirt_size" :label="__('Shirt Size')" >
                        <option value="s">{{ __('S') }}</option>
                        <option value="m">{{ __('M') }}</option>
                        <option value="l">{{ __('L') }}</option>
                        <option value="xl">{{ __('XL') }}</option>
                        <option value="xxl">{{ __('XXL') }}</option>
                    </field-select>

                    <hr class="my-4">

                    <field-input class="mb-0" v-model="referredEmail" @blur="verifyReferral($event)" label="Referred By (Student Email)"></field-input>
                    <div v-if="form.referred_by" class="text-danger" v-text="form.referred_by.full_name"></div>

                </div>
            </tab-content>

            <tab-content :title="__('Emergency Contact')" icon="fas fa-ambulance">
                <div class="section mb-5">
                    <field-input v-model="form.emergency_contact_name" name="emergency_contact_name" label="Name"></field-input>
                    <field-phone v-model="form.emergency_contact_phone" name="emergency_contact_phone" label="Phone"></field-phone>
                </div>
            </tab-content>

            <tab-content :title="__('Employer')" icon="fas fa-tools" :tab="{data:{active:true}}">
                <div class="section mb-5">
                    <field-checkbox class="mb-3" v-model="form.unemployed" label="I'm Unemployed"></field-checkbox>
                    <field-input v-model="form.employer_name" name="employer_name" label="Employer name" :readonly="form.unemployed"></field-input>
                    <field-phone v-model="form.employer_phone" name="employer_phone" label="Employer phone number" :readonly="form.unemployed"></field-phone>
                    <field-input type="email" v-model="form.employer_email" name="employer_email" label="Employer email" :readonly="form.unemployed"></field-input>
                </div>
            </tab-content>

            <tab-content :title="__('Agreement')" icon="far fa-handshake" class="pb-3" v-if="!agreementAt">
                <div class="form-group">
                    <p><a target="_blank" :href="`/students-handbook/${form.type}`" class="text-app-blue" v-text="__('Click Here to Download the CET Student Handbook.')"></a></p>
                    <p clas="mb-2">
                        {{ __('By typing their name below, the undersigned certifies that (s)he has carefully reviewed the information presented in the description of the program and CET’s Student Handbook. The undersigned certifies that (s)he is fluent in the language chosen to conduct the coursework and clearly understands the consequences that will arise due to failure to comply with the guidelines stipulated by the program.') }}
                    </p>
                    <field-input v-model="form.agreement_at" name="agreement_at" label="Type your full name"></field-input>
                </div>
            </tab-content>

            <tab-content :title="__('Payment')" icon="fas fa-dollar-sign" class="pb-3">
                <div class="form-group" v-if="!form.payment_at">
                    <p>{{ __('Application Fee') }}: <b class="text-danger" v-text="applicationFee"></b></p>
                    <payment-form v-model="form.stripe_token" @error="onError"></payment-form>
                </div>
                <div class="form-group" v-else>
                    <span class="font-bold text-danger">Your application is Paid!</span>
                </div>

                <div class="form-group">
                    <field-input v-model="form.program_promo_code" name="program_discount_code" label="Program Discount Code"></field-input>
                </div>

            </tab-content>

            <template slot="footer" slot-scope="props">
                <div class="wizard-footer-left">
                    <wizard-button v-if="props.activeTabIndex > 0 && !props.isLastStep" @click.native="props.prevTab()" :style="props.fillButtonStyle">
                        {{ __('Previous') }}
                    </wizard-button>
                </div>
                <div class="wizard-footer-right">
                    <wizard-button v-if="!props.isLastStep" @click.native="props.nextTab()" class="wizard-footer-right" :style="props.fillButtonStyle">
                        {{ __('Next') }}
                    </wizard-button>
                    <wizard-button v-else @click.native="submit()" :disabled="form.isSubmitted" class="wizard-footer-right finish-button" :style="props.fillButtonStyle">
                        <i v-if="form.isSubmitted" class="fa fa-spinner fa-spin"></i> {{ finishButtonText }}
                    </wizard-button>
                </div>
            </template>

        </form-wizard>
    </div>
</template>
<script>

    let AutoCompleteAddress = require('@/mixins/AutoCompleteAddress');

    export default {

        mixins: [AutoCompleteAddress],

        props:['applicationFee'],

        data() {
            return {
                currentUser: null,
                userId: App.config.userId,
                agreementAt: null,
                referredEmail: '',
                form: new Form({
                    id: null,
                    type: (App.config.locale == 'en') ? 'english_online' : 'spanish_online',

                    address: config.debug ? '12819 Orr And Day Rd' : '',
                    city: config.debug ? 'La Paz' : '',
                    state: config.debug ? 'CA' : '',
                    zip: config.debug ? '90650' : '',

                    birth_date: config.debug ? '12/23/1988' : '',
                    driver_license: config.debug ? 'Y12312232' : '',
                    file_id: '',
                    goverment_id_file_attached_at: null,
                    shirt_size: config.debug ? 'm' : null,
                    referred_by_user_id: null,

                    emergency_contact_name: config.debug ? 'Jana Doe' : '',
                    emergency_contact_phone: config.debug ? '+156225412' : '',

                    unemployed: config.debug ? true : false,
                    employer_name: '',
                    employer_phone: '',
                    employer_email: '',

                    agreement_at: config.debug ? '' : '',
                    payment_at: null,
                    approved_at: null,

                    with_payment: false,
                    stripe_token: null,
                    program_promo_code: '',

                }).dontClear()
            }
        },

        created() {
            this.refreshApplication();
        },

        methods: {

            refreshApplication() {
                this.form.get(`/electrical-training-program/application/${this.userId}`).then(data => {
                    let application = data.application
                    this.currentUser = data.user
                    if (application) {

                        var data = application.payment_at ? application : {
                            ...application, ...{
                                stripe_token: null,
                                with_payment: false,
                                shirt_size: this.currentUser.shirt_size,
                                program_discount_code: config.debug ? '' : '',
                            }
                        }
                        this.form = new Form(data).dontClear()
                        this.activateSteps();

                        /// Set the agreement variables.
                        this.agreementAt = application.agreement_at;
                        this.form.agreement_at = null;

                    }
                }).catch(errors => {
                    Alert.error(errors.first())
                })
            },

            submit() {
                this.form.post(`/electrical-training-program/application`)
                    .then(response => {
                        this.refreshApplication();
                        Alert.timer(response.message).then(() => {
                            if (response.payment) {
                                this.redirectTo('/')
                            }
                        })
                    }).catch(errors => {
                    Alert.error(errors.first())
                })
            },

            remove() {
                this.form.delete(`/electrical-training-program/application`).then(response => {
                    Alert.success(__('The application has been deleted.'));
                    this.refreshApplication();
                }).catch(errors => {
                    Alert.error(errors.first())
                })
            },

            onError() {
                this.form.isSubmitted = false;
            },

            activateSteps() {
                var wizard = this.$refs.application
                wizard.maxStep = wizard.tabs.length - 1
                wizard.tabs.forEach((tab) => {
                    tab.checked = true
                })
            },

            updateGovermentIdFileAttachedEvent() {
                this.form.goverment_id_file_attached_at = moment().format()
            },

            verifyReferral(){
                App.request().post(`/api/verify-referral`, {email: this.referredEmail})
                .then(response => {
                    console.log(response.data)
                    this.form.referred_by_user_id = response.data.user ? response.data.user.id : null;
                })
            }
        },

        watch: {
            'form.stripe_token'(value) {
                this.form.with_payment = !!value;
            }
        },

        computed: {
            finishButtonText() {
                if (this.form.isSubmitted) return this.__('Updating Application...')
                return (!this.form.payment_at && this.form.stripe_token) ? this.__('Complete Payment') : this.__('Save Application')
            },

            approvedAndReadyToMakeFirstPayment() {
                return this.form && this.form.approved_at && this.form.training_quarters.length == 0;
            }
        }
    }
</script>
